import React from 'react';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Box, Button, CardActions, CardContent, Grid, Link, Paper, TextField, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer, MessageDisplay } from '@/components';
import { useAppContext } from '@/context';
import { useFRCallback } from '@/hooks';

// this page node typically renders for the 'ForgottenUsername001' stage value
const EnterEmailAddress = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;
  const { setMessages } = useAppContext();
  const { callbacks = [] } = useFRCallback(stepToRender);

  // initialize form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = (values) => {
    setMessages([]); // clear out error messages on submit
    const output = { ...stepToRender };

    // TODO: flesh out proper logic
    if (values) {
      const { email } = values;

      const newCallbacks = [...callbacks];
      for (const [index, callbackField] of newCallbacks.entries()) {
        const { input } = callbackField;

        const tokenIndex = findIndex(input, (inputObj) => inputObj.name === 'IDToken1');

        newCallbacks[index].input[tokenIndex] = {
          ...newCallbacks[index]?.input[tokenIndex],
          value: email,
        };
      }

      Object.assign(output.payload.callbacks, [...newCallbacks]);

      setCurrentStep({ ...output });
    }
  };

  return (
    <Grid
      id="enter-email-address-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '500px' } }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <CardContent>
                <Typography variant="h1" mb={2}>
                  Forgot your user ID?
                </Typography>
                <Box mb={3}>
                  <TextField
                    id="email"
                    label="Email"
                    margin="normal"
                    display="flex"
                    {...register('email', {
                      maxLength: {
                        value: 60,
                        message: 'The email address you entered is not in a valid format. Please try again.',
                      },
                      required: 'The email address you entered is not in a valid format. Please try again.',
                      pattern: {
                        value:
                          /^[\w!#$&'+/-]+(?:\.[\w!#$&'+/-]+)*@(?:[\da-z](?:[\da-z-]*[\da-z])?\.)+[\da-z](?:[\da-z-]*[\da-z])?$/i,
                        message: 'The email address you entered is not in a valid format. Please try again.',
                      },
                    })}
                    placeholder="Enter your email address."
                    error={!!errors.email}
                    helperText={errors.email?.message}
                  />
                </Box>
                <MessageDisplay />
              </CardContent>
              <CardActions sx={{ justifyContent: 'space-between' }}>
                <Link
                  color="tertiary"
                  href="#/login"
                  loadApp={false}
                  onClick={() => {
                    setMessages([]); // clear out messages on route navigation
                  }}
                >
                  Nevermind. Take me to login.
                </Link>{' '}
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </CardActions>
            </form>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

EnterEmailAddress.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default EnterEmailAddress;
